<ng-container *ngIf="showData">
    <ng-container *ngFor="let tabla of data">
        <div class="col-12 my-4 card-print">
            <mat-accordion>
                <mat-expansion-panel class="filtros-panel"
                    (opened)="panelOpenState[tabla?.title] = true"
                    (closed)="panelOpenState[tabla?.title] = false"
                    [expanded]="panelOpenState[tabla?.title]"
                    togglePosition="before">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-chip class="chip-info mr-3 div-print"><i class="fa fa-info" aria-hidden="true"></i></mat-chip>
                            {{tabla?.title || ''}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-12 mx-auto col-12-print">
                            <div class="table-responsive border p-3 print-no-border col-12-print">
                                <table mat-table [dataSource]="tabla?.rows" class="info-basica-table">
    
                                    <ng-container *ngFor="let item of tabla?.columns; let i = index">
                                        <ng-container [matColumnDef]="item">
                                            <th mat-header-cell *matHeaderCellDef class="text-wrap cell-font-size bg-white border-bottom-0 fw-bolder"> {{tabla?.headers[item] || ''}} </th>
                                            <td mat-cell *matCellDef="let element" class="cell-font-size text-nowrap" [ngClass]="(element?.classes[item]) ? element?.classes[item] : ''" >
                                                <ng-container *ngTemplateOutlet="dataTemplate; context: { $implicit: {type: element?.types[item], value: element?.values[item]} }"></ng-container>
                                                <ng-container *ngIf="tabla?.headers[item] == 'Mes' && element?.values?.validadoSoloFolio === true">
                                                    <mat-icon 
                                                        class="align-middle mb-1 ms-1 icon-warning" 
                                                        aria-hidden="false" 
                                                        aria-label="Error icon" 
                                                        fontIcon="error"
                                                        [matTooltip]="'Este mes no fue validado en SII, debido a indisponibilidad de fuente.'"
                                                        matTooltipClass="tooltip-multilinea"
                                                    >
                                                    </mat-icon>
                                                </ng-container>
                                            </td>
                                        </ng-container>                                        
                                    </ng-container>
                                    
                                    <tr mat-header-row *matHeaderRowDef="tabla?.columns"></tr>
                                    <tr
                                        mat-row
                                        *matRowDef="let row; columns: tabla?.columns;"
                                    ></tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </ng-container>
</ng-container>

<ng-template #dataTemplate let-elemento>
    <ng-container [ngSwitch]="elemento?.type">
        <ng-container *ngSwitchCase="'rut'">
            {{elemento?.value ? (elemento?.value | rutFormat) : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
            {{elemento?.value ? (elemento?.value | date: 'dd-MM-yyyy') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'int'">
            {{elemento?.value || elemento?.value == 0 ? (elemento?.value | number: '1.0-0') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'int1'">
            {{elemento?.value || elemento?.value == 0 ? (elemento?.value | number: '1.0-1') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'porc'">
            {{elemento?.value || elemento?.value == 0 ? (elemento?.value | number: '1.0-2') : ''}}
        </ng-container>
        <ng-container *ngSwitchCase="'dateMes'">
            {{elemento?.value ? (elemento?.value | date: 'LLLL') : ''}}
        </ng-container>
        <ng-container *ngSwitchDefault>
            {{elemento?.value}}
        </ng-container>
    </ng-container>
</ng-template>